import React, { lazy, Suspense } from "react";

import { FaCheck } from "react-icons/fa6";
import mobile364 from "@/assets/citywise/waggex-payroll-software-chennai-hero-section.webp";
import mobile556 from "@/assets/citywise/waggex-payroll-software-chennai-hero-section.webp";
import HomeFaq from "../../pages/HomeFaq";
import { Helmet } from "react-helmet-async";
const Whywaggexcommonchoice = lazy(
  () => import("./common/Whywaggexcommonchoice"),
);

const LookingforPayroll = lazy(() => import("./common/LookingforPayroll"));

const FAQ = lazy(() => import("../../pages/Faq"));

const AppDownloadCard = lazy(() => import("../common/AppDownloadCard"));

const PayrollBanner = lazy(() => import("../common/PayrollBanner"));

const ModernizeHR = lazy(() => import("../common/ModernizeHR"));

const Chennai = () => {
  const faq1 = [
    {
      title: "How can payroll software help businesses in Chennai?",
      content:
        "Payroll software automates salary calculations, attendance integration, leave deductions, payslip generation, and employee records. It helps Chennai businesses reduce manual work, improve payroll accuracy, and process salaries more efficiently every month.",
    },
    {
      title: "Can payroll and attendance be managed from one platform?",
      content:
        "Yes. Payroll and attendance work together on a single platform, allowing businesses to calculate salaries using attendance, approved leave, shifts, and overtime without maintaining separate records.",
    },
    {
      title: "Is the software suitable for startups and SMEs in Chennai?",
      content:
        "Absolutely. The platform is designed for startups, SMEs, manufacturing units, retail businesses, IT companies, and growing organizations looking to simplify payroll, attendance, and day-to-day HR operations.",
    },
  ];

  const faq2 = [
    {
      title: "Can employees access HR services from their mobile phones?",
      content:
        "Yes. Employees can use the Staff App to mark attendance, submit leave requests, download payslips, view attendance history, and receive important company notifications anytime.",
    },
    {
      title: "Does the software help reduce manual HR work?",
      content:
        "Yes. By automating payroll processing, attendance tracking, leave approvals, employee records, and routine HR tasks, businesses can save time, reduce administrative effort, and improve workforce efficiency.",
    },
  ];
  const schema = [
    {
      "@context": "https://schema.org",
      "@type": "SoftwareApplication",

      name: "Waggex",
      applicationCategory: "BusinessApplication",
      operatingSystem: "Web, Android, iOS",

      url: "https://www.waggex.com/best-payroll-software-in-chennai",
      image: "https://www.waggex.com/waggex-payroll-software-logo.png",

      description:
        "Best payroll software in Chennai for businesses and SMEs. Streamline payroll processing, attendance tracking, leave management, employee records, and workforce management.",
      aggregateRating: {
        "@type": "AggregateRating",
        ratingValue: "4.9",
        ratingCount: "250",
        bestRating: "5",
        worstRating: "1",
      },
      provider: {
        "@type": "Organization",
        name: "Waggex",
        url: "https://www.waggex.com/",
        logo: "https://www.waggex.com/waggex-payroll-software-logo.png",

        areaServed: {
          "@type": "Country",
          name: "India",
        },

        contactPoint: {
          "@type": "ContactPoint",
          telephone: "+91-01724534553",
          email: "Info@waggex.com",
          contactType: "customer support",
        },
      },

      offers: {
        "@type": "Offer",
        price: "0",
        priceCurrency: "INR",
        description: "Free trial available",
      },

      featureList: [
        "Payroll software Chennai",
        "Attendance management software Chennai",
        "Leave and shift management Chennai",
        "Face recognition attendance Chennai",
        "Employee self-service app",
        "GPS attendance tracking",
        "Automated payroll processing",
        "AI selfie attendance",
      ],
    },

    {
      "@context": "https://schema.org",
      "@type": "Organization",

      name: "Waggex",
      url: "https://www.waggex.com/best-payroll-software-in-chennai",
      logo: "https://www.waggex.com/waggex-payroll-software-logo.png",

      description:
        "Waggex provides payroll and HRMS software for businesses in Chennai and across India.",

      areaServed: "IN",

      contactPoint: {
        "@type": "ContactPoint",
        contactType: "customer support",
        availableLanguage: ["English", "Hindi", "Tamil"],
      },
    },
  ];
  return (
    <>
      <Helmet>
        <title>Best Payroll Software With HR Management In Chennai</title>
        <meta
          name="description"
          content="Best payroll software with HR management in Chennai for businesses of all sizes. Automate payroll, HR, attendance, leave, and statutory compliance seamlessly"
        />
        <meta
          name="keywords"
          content="payroll software in Chennai,payroll software Chennai,HR software for businesses in Chennai,attendance management software Chennai,HRMS software Chennai,online payroll system Chennai,employee management software Chennai,leave management software Chennai,face recognition attendance Chennai,payroll software for manufacturing companies Chennai,
payroll software for IT companies Chennai"
        />
        <link
          rel="canonical"
          href="https://www.waggex.com/best-payroll-software-in-chennai"
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(schema),
          }}
        />
      </Helmet>
      <section className="w-full bg-[#d1dfea] overflow-hidden py-10 px-6">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 items-center gap-10">
            {/* Left Content */}
            <div className="text-center lg:text-left">
              {/* Heading */}
              <h1 className="mt-6 text-[#10324F] font-bold uppercase tracking-wide text-xl md:text-[28px] min-h-16">
                Best Payroll Software in Chennai for Businesses
              </h1>
              <h2 className="mt-4 text-[#10324F] font-semibold text-sm md:text-lg">
                Spend Less Time on Payroll. More Time Growing Your Business
              </h2>
              {/* Description */}
              <p className="service-list-item-text py-4 max-w-xl">
                Managing payroll, attendance, leave, and employee records
                manually can slow your business down. <strong>Waggex </strong>
                brings everything together in one HRMS platform, helping Chennai
                businesses automate payroll processing, improve salary accuracy,
                reduce HR workload, and stay organized as teams grow
              </p>

              {/* Buttons */}
              <div className="mt-8 flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
                <button
                  onClick={() =>
                    (window.location.href = "https://app.waggex.com/signup")
                  }
                  className="w-full sm:w-auto bg-[#10324F] hover:bg-[#10324F] transition-all duration-300 text-white px-14 py-3 rounded-xl shadow-md text-sm sm:text-base font-medium"
                >
                  Start Free Trial
                </button>

                <button
                  onClick={() => (window.location.href = "/contact-us")}
                  className="w-full sm:w-auto border border-[#10324F] text-[#10324F] hover:bg-[#10324F] hover:text-white transition-all duration-300 px-14 py-3 rounded-xl text-sm sm:text-base font-medium"
                >
                  Book a Demo
                </button>
              </div>
            </div>

            {/* Right Image */}
            <div className="relative flex justify-center items-center">
              {/* Phones Image */}
              <picture>
                <source media="(max-width: 639px)" srcSet={mobile364} />

                <img
                  src={mobile556}
                  fetchPriority="high"
                  width={400}
                  height={360}
                  loading="eager"
                  decoding="async"
                  alt="Waggex payroll software Chennai simplify payroll and attendance management for businesses and SMEs"
                  className="relative object-contain"
                />
              </picture>
            </div>
          </div>
        </div>
      </section>
      <section className="bg-[#FFFFFF] py-10 px-6">
        <div className="max-w-6xl mx-auto">
          {/* Heading */}
          <div className="text-center">
            <h2 className="text-[#10324F] text-xl md:text-3xl font-bold uppercase">
              Built for Chennai's Growing Businesses
            </h2>
            <p className="mt-4 text-[#10324F] text-sm leading-relaxed">
              Whether you manage office employees, factory workers, field staff,
              or shift-based teams, <strong>Waggex </strong> makes payroll and
              workforce management simple. Chennai businesses use{" "}
              <strong>Waggex </strong> to automate attendance, salary
              processing, leave tracking, and HR operations while reducing
              paperwork and saving valuable time
            </p>
          </div>
          {/* List */}
          <div className="mt-10 flex justify-center">
            <div className="grid grid-cols-2 gap-x-5 md:gap-x-20 gap-y-5">
              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Automated Payroll Processing</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Shift Management</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Attendance-Based Salary Calculation</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>PDF Payslip Generation</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>AI Selfie Attendance</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Employee Self-Service App</span>
              </div>
              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>GPS Attendance Tracking</span>
              </div>
              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Real-Time Notifications</span>
              </div>
              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Employee Leave Management</span>
              </div>
              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Face Recognition Attendance</span>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="bg-[#F3F5F7] py-10 px-6">
        <div className="max-w-6xl mx-auto">
          {/* Heading */}
          <div className="text-center">
            <h2 className="text-[#10324F] text-xl md:text-3xl font-bold uppercase">
              Automate Payroll Processing Without the Manual Work
            </h2>

            <p className="mt-4 text-[#10324F] text-sm sm:text-base">
              Processing payroll manually can lead to salary errors, delayed
              payments, and unnecessary administrative work.
              <strong>Waggex </strong> automates payroll calculations by
              connecting attendance, leave records, shifts, and employee data,
              helping Chennai businesses process salaries faster while improving
              accuracy and operational efficiency
            </p>
          </div>
          {/* List */}
          <div className="mt-10 flex justify-center">
            <div className="grid grid-cols-2 gap-x-5 md:gap-x-20 gap-y-5">
              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Automated payroll calculation</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Employee salary reports</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Attendance-based payroll processing</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Payroll history and records</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Overtime and shift salary management</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Employee payroll notifications</span>
              </div>
              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Payslip generation in PDF format</span>
              </div>
            </div>
          </div>{" "}
          <p className="mt-8 text-[#10324F] text-sm sm:text-base text-center max-w-3xl mx-auto leading-loose">
            Once payroll is processed, employees receive instant notifications
            and can securely view or download their payslips anytime through the
            <strong>Waggex Staff App</strong> or employee portal reducing HR
            queries and saving valuable administrative time
          </p>
        </div>
      </section>
      <section className="bg-[#FFFFFF] py-10 px-6">
        <div className="max-w-6xl mx-auto">
          {/* Heading */}
          <div className="text-center">
            <h2 className="text-[#10324F] text-xl md:text-3xl font-bold uppercase">
              Accurate Attendance Tracking for Every Employee
            </h2>

            <p className="mt-4 text-[#10324F] text-sm sm:text-base">
              Tracking attendance for office employees, factory workers, field
              teams, and shift-based staff can be challenging.{" "}
              <strong>Waggex </strong> combines AI face recognition, GPS
              attendance, geo-fencing, and mobile attendance to help Chennai
              businesses improve attendance accuracy, reduce manual work, and
              simplify payroll processing
            </p>
          </div>
          {/* List */}
          <div className="mt-10 flex justify-center">
            <div className="grid grid-cols-2 gap-x-5 md:gap-x-20 gap-y-5">
              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>AI Selfie Attendance</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Shift-Based Attendance</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>GPS Attendance Tracking</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Mobile Attendance Marking</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Geofencing</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Real-Time Attendance Reports</span>
              </div>
              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>FaceLens AI Face Recognition Attendance</span>
              </div>
            </div>
          </div>{" "}
          <p className="mt-8 text-[#10324F] text-sm sm:text-base text-center">
            Connect attendance with payroll, leave management, and employee
            records from one centralized platform, reducing manual work and
            ensuring accurate salary processing every month
          </p>
        </div>
      </section>
      <section className="bg-[#F3F5F7] py-10 px-6">
        <div className="max-w-6xl mx-auto">
          {/* Heading */}
          <div className="text-center">
            <h2 className="text-[#10324F] text-xl md:text-3xl font-bold uppercase">
              Simplify Leave Management & Shift Scheduling
            </h2>

            <p className="mt-4 text-[#10324F] text-sm sm:text-base">
              <strong>Waggex </strong> streamlines leave requests and shift
              scheduling with automated workflows, approval processes, and
              instant notifications, helping HR teams reduce manual coordination
              and improve workforce planning
            </p>
          </div>

          {/* List */}
          <div className="mt-10 flex justify-center">
            <div className="grid grid-cols-2 gap-x-5 md:gap-x-20 gap-y-5">
              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Yearly leave allocation</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Leave approval workflow</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Leave balance tracking</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Real-time leave notifications</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Attendance-based leave management</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Shift management</span>
              </div>
            </div>{" "}
          </div>
          <p className="mt-8 text-[#10324F] text-sm sm:text-base text-center max-w-2xl mx-auto leading-loose">
            Employees receive instant notifications when leave requests are
            submitted, approved, or rejected, keeping everyone informed while
            reducing follow-ups with HR
          </p>
        </div>
      </section>
      <section className="bg-[#FFFFFF] py-10 px-6">
        <div className="max-w-6xl mx-auto">
          {/* Heading */}
          <div className="text-center">
            <h2 className="text-[#10324F] text-xl md:text-3xl font-bold uppercase">
              Empower Employees with the Waggex Staff App
            </h2>
            <p className="mt-4 text-[#10324F] text-sm sm:text-base">
              Give employees the freedom to mark attendance, apply for leave,
              download payslips, and access important HR information from one
              mobile app reducing HR dependency and saving valuable
              administrative time
            </p>
            <p className="mt-4 text-[#10324F] text-lg">Employee Can:</p>
          </div>
          {/* List */}
          <div className="mt-10 flex justify-center">
            <div className="grid grid-cols-2 gap-x-5 md:gap-x-20 gap-y-5">
              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Mark attendance</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>View attendance history</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Apply for leave </span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Receive notifications</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Download payslips</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Access employee records</span>
              </div>
            </div>
          </div>{" "}
          <p className="mt-8 text-[#10324F] text-sm sm:text-base text-center">
            Employees can complete everyday HR tasks independently while HR
            teams spend less time answering routine requests and more time
            focusing on business priorities
          </p>
        </div>
      </section>
      <section className="bg-[#F3F5F7] py-10 px-6">
        <div className="max-w-6xl mx-auto">
          {/* Heading */}
          <div className="text-center">
            <h2 className="text-[#10324F] text-xl md:text-3xl font-bold uppercase">
              Built for Businesses of Every Size and Industry
            </h2>

            <p className="mt-4 text-[#10324F] text-lg">
              Waggex is suitable for:
            </p>
          </div>

          {/* List */}
          <div className="mt-10 flex justify-center">
            <div className="grid grid-cols-2 gap-x-5 md:gap-x-20 gap-y-5">
              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Startups</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Factories</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>SMEs</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Service Companies</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>IT Companies</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Field Workforce Businesses</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Retail Businesses</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Agencies & Consultancies</span>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Suspense fallback={null}>
        <Whywaggexcommonchoice
          heading="The Smarter Way to Manage Your Workforce"
          description="Managing payroll and workforce operations shouldn't require spreadsheets, manual calculations, and disconnected tools. A centralized HRMS helps businesses automate payroll, attendance, leave management, and employee records while saving time and improving operational efficiency"
          paragraph=""
        />
        <LookingforPayroll
          heading="Ready to Simplify Payroll & HR Management?"
          subHeading="Book a Free Demo and Explore Waggex Features"
          description="Automate payroll, attendance, leave management, shifts, and employee records from one centralized platform designed to help Chennai businesses save time, reduce manual work, and improve payroll accuracy"
          features={[
            "AI Attendance Management",
            "Payroll Automation",
            "Employee Self-Service App",
            "GPS & Face Recognition Attendance",
            "Attendance-Based Payroll",
            "Real-Time Notifications",
          ]}
          buttonText="Book Free Demo"
        />
        <HomeFaq
          faq1={faq1}
          faq2={faq2}
          subtitle="Everything you need to know about Waggex payroll software in India"
        />
        {/*  <AppDownloadCard /> */}
        <PayrollBanner
          heading="Need Payroll Software for Your Business?"
          description="Discover Waggex Payroll Software to automate salary processing, statutory compliance, payslip generation, and payroll management all from one secure, cloud-based platform"
        />
        <AppDownloadCard />
        <ModernizeHR />
      </Suspense>
    </>
  );
};

export default Chennai;
